import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider,
} from "react-router-dom";
import WalletConnectProvider from "./context/wallet-connection";
import { WagmiProvider } from "wagmi";
import { PersistQueryClientProvider } from "@tanstack/react-query-persist-client";
import { wagmiConfig } from "./config/wagmiConfig";
import { queryClient, persister } from "./config/tanstackConfig";
import AppRootContext from "./context/app-context";
import StakingContextProvider from "./context/staking-context";
import DashboardPage from "./pages/dashboard";
import BecomeValidator from "./pages/becomeValidator";
import Delegate from "./pages/delegate";
import Calculator from "./pages/calculator";
import FreqAskQuestions from "./pages/faq";
import DetailPage from "./pages/detail-page";
import AllValidator from "./pages/allValidator";
import MyAccount from "./pages/my-account";
import TransactionHistory from "./pages/transaction-history";
import UnstakeIndex from "./pages/my-account/UnstakeIndex";
import ClaimUnstakeIndex from "./pages/my-account/ClaimUnstakeIndex";
import { Buffer } from "buffer";
import TermsAndConditions from "./pages/terms";
import PrivacyPolicy from "./pages/privacy-policy";

// Make Buffer available globally
window.Buffer = Buffer;

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route
      path="/"
      element={
        <StakingContextProvider>
          <App />{" "}
        </StakingContextProvider>
      }
    >
      <Route path="/" element={<DashboardPage />} />
      <Route path="/validator" element={<BecomeValidator />} />
      <Route path="/delegate" element={<Delegate />} />
      <Route path="/calculator" element={<Calculator />} />
      <Route path="/faqs" element={<FreqAskQuestions />} />
      <Route path="/validator/:id" element={<DetailPage />} />
      <Route path="/all-validator" element={<AllValidator />} />
      <Route path="/my-account" element={<MyAccount />} />
      <Route path="/my-account/unstake" element={<UnstakeIndex />} />
      <Route path="/my-account/claim-unstake" element={<ClaimUnstakeIndex />} />
      <Route path="/transaction-history" element={<TransactionHistory />} />
      <Route path="/terms" element={<TermsAndConditions />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
    </Route>
  )
);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <WagmiProvider config={wagmiConfig}>
    <PersistQueryClientProvider
      client={queryClient}
      persistOptions={{ persister }}
    >
      <AppRootContext>
        <WalletConnectProvider>
          <RouterProvider router={router} />
        </WalletConnectProvider>
      </AppRootContext>
    </PersistQueryClientProvider>
  </WagmiProvider>
);

reportWebVitals();
